import { SpintrTypes } from "src/typings";
import MarketplaceDataLoader from "./data-loader";

/**
 * Drops the stored response of every upcoming events puff on the start page.
 *
 * Call this after a calendar event has been created, changed or removed, so the
 * puff loads current data instead of reusing a response fetched before the
 * change. Only those puffar are touched - every other data widget keeps its
 * stored response.
 */
export const clearCalendarWidgetCache = (teaserBoxes: Spintr.ITeaserBoxItem[]): void => {
    (teaserBoxes || [])
        .filter((teaserBox) =>
            teaserBox.widgetDisplayType === SpintrTypes.WidgetType.UpcomingEvents &&
            !!teaserBox.widgetConfigurationId
        )
        .forEach((teaserBox) => MarketplaceDataLoader.remove(teaserBox.widgetConfigurationId));
};

export default clearCalendarWidgetCache;
